import React, { Component, useEffect, useState } from 'react';
import { isHebrew } from '../../../App';
import { makeStyles } from '@material-ui/core/styles';

import {
  Box,
  Grid,
  Typography,
  Container,
  Divider,
  IconButton,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  textDetail: {
    color: 'rgba(255, 255, 255, 0.8)',
  },
}));

const faqJsonQuestions = [
  'How long does it take for my KRE8.TV Video to be delivered?',
  'Can I extend the license on my Business KRE8.TV Video?',
  'Can I remove the KRE8.TV watermark or add my company logo to the video?',
  'What if I’m not satisfied with the KRE8.TV Video that gets delivered?',
  'Can I make a compilation video that uses multiple KRE8.TVs?',
];

const faqJsonAnswers = [
  'Creators have up to 7 days to complete requests they receive. While the turnaround time is typically much quicker, please keep this in mind for any time sensitive needs. If the creator does not deliver the video within 7 days you will be credited back the full amount.',
  'We offer license extensions around term and usage. You can add days to your license or add marketing channels for an additional fee. Reach out to your rep to learn more about pricing.',
  'The KRE8.TV watermark cannot be deleted, however we do offer co-branded watermarks for an additional charge. Reach out to your rep to learn more about pricing. The videos cannot be edited when purchased self-service.',
  "With the Enterprise service, you can reach out to your rep and they'll help make it right. We can offer redos if the creator says a name incorrectly or misses the mark. When booking self-service, you'll work with our customer service team (contact@KRE8.TV.com).",
  'You can create compilation videos using KRE8.TVs with the Enterprise service. We do need to approve the compilation videos once finalized, so make sure to work closely with your rep on those projects. This is only available to Enterprise customers.',
];

const faqJsonQuestions_hebrew = [
  'כמה זמן לקבל את את הסרטונים שלי?',
  'האם אוכל להרחיב את הרישיון לסרטון KRE8.TV העסקי שלי?',
  'האם אוכל להסיר את סימן המים KRE8.TV או להוסיף את לוגו החברה שלי לסרטון?',
  'מה אם אני לא מרוצה מסרטון KRE8.TV שמסופק?',
  'האם אוכל ליצור סרטון אוסף שעושה שימוש במספר סרטונים?',
];

const faqJsonAnswers_hebrew = [
  'ליוצרים יש עד 7 ימים להשלים את הבקשות שהם מקבלים. למרות שזמן התפנית בדרך כלל הרבה יותר מהיר, אנא זכור זאת בכל עת לצרכים רגישים. אם הסלב לא ימסור את הסרטון תוך 7 ימים תזוכה בחזרה את מלוא הסכום.',
  'אנו מציעים הרחבות רישיון סביב תקופת השימוש. תוכל להוסיף ימים לרישיון שלך או להוסיף ערוצי שיווק בתוספת תשלום. פנה לנציג שלך למידע נוסף על מחירים.',
  'לא ניתן למחוק את סימן המים KRE8.TV, אולם אנו מציעים סימני מים מותגים משותפים תמורת תשלום נוסף. פנה לנציג שלך למידע נוסף על מחירים. לא ניתן לערוך את הסרטונים ברכישה בשירות עצמי.',
  'עם שירות עסקי, תוכל לפנות לנציג שלך והם יעזרו לעשות את זה כמו שצריך. אנחנו יכולים להציע שינויים חוזרים אם היוצר אומר שם לא נכון או מחמיץ את הסימן. בעת הזמנת שירות עצמי, תעבוד עם צוות שירות הלקוחות שלנו (contact@KRE8.TV.com).',
  'באפשרותך ליצור סרטוני אוסף באמצעות מכשירי KRE8.TV עם שירות עסקי. אנחנו אכן צריכים לאשר את סרטוני האוסף לאחר שסיימו, לכן אנו מקפידים לעבוד בשיתוף פעולה הדוק עם הנציג שלך בפרויקטים אלה. זה זמין רק ללקוחות ארגוניים.',
];

const FAQBox = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const [isOpen, setIsOpen] = useState(false);
  const { title, detail, isLast } = props;

  return (
    <Box flexDirection="column" width="100%" p={1}>
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="h5">
            <Box
              onClick={() => setIsOpen(!isOpen)}
              fontWeight="bold"
              color="white"
              fontSize="18px"
              className={`${classes.textDetail} clickable`}
            >
              {title}
            </Box>
          </Typography>
        </Box>
        <Box className={classes.textDetail}>
          <IconButton
            className={classes.textDetail}
            onClick={() => setIsOpen(!isOpen)}
          >
            {!isOpen ? <AddIcon /> : <RemoveIcon />}
          </IconButton>
        </Box>
      </Box>
      <Box display={isOpen ? 'block' : 'none'}>
        <Typography variant="body2">
          <Box fontSize="16px" lineHeight="24px" className={classes.textDetail}>
            {detail}
          </Box>
        </Typography>
      </Box>
      <Box mt={2} display={isLast ? 'none' : 'block'}>
        <Divider style={{ background: 'rgba(255, 255, 255, 0.3)' }} />
      </Box>
    </Box>
  );
};

export const FAQSection = () => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const { t, i18n } = useTranslation();

  const questions = isHebrew() ? faqJsonQuestions_hebrew : faqJsonQuestions;
  const answers = isHebrew() ? faqJsonAnswers_hebrew : faqJsonAnswers;

  return (
    <Box className={classes.faq}>
      <Typography variant="h5">
        <Box fontWeight="bold" color="white" fontSize="32px" textAlign="center">
          {t('biz_lp_faq_title')}
        </Box>
      </Typography>
      <Container maxWidth="md">
        <Box
          className={classes.faqItemsContainer}
          mt={4}
          borderRadius="24px"
          border={1}
          borderColor="white"
          p={2}
        >
          {questions.map((items, index) => {
            return (
              <FAQBox
                isLast={index === questions.length - 1}
                title={questions[index]}
                detail={answers[index]}
              />
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
